var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOfekHe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 39.419,
    viewBox: "0 0 124 39.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2482",
    "data-name": "Rectangle 2482",
    width: 124,
    height: 39.419,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4589-2",
    "data-name": "Group 4589",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4283",
    "data-name": "Path 4283",
    d: "M166.256,19.591a2.283,2.283,0,0,0-2.446,2.137V41.141a2.453,2.453,0,0,0,4.893,0V21.728a2.283,2.283,0,0,0-2.446-2.137",
    transform: "translate(-102.179 -12.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4284",
    "data-name": "Path 4284",
    d: "M23.492,22.343a2.016,2.016,0,0,0-2.175-1.974H2.2A2.233,2.233,0,0,0,0,22.815a2.086,2.086,0,0,0,2.2,2.372H17.8L12.666,40.875a2.267,2.267,0,0,0,1.614,2.932,2.12,2.12,0,0,0,2.965-1.433l6.066-18.53a2.663,2.663,0,0,0,.132-.422,2.279,2.279,0,0,0,.048-1.079",
    transform: "translate(0 -12.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4285",
    "data-name": "Path 4285",
    d: "M100.9,22.425a2.3,2.3,0,0,0-2.446-2.115c-.054,0-.106,0-.16.007s-.084-.006-.127-.006H73.853a2.635,2.635,0,0,0-2.784,2.446A2.635,2.635,0,0,0,73.853,25.2h1.559v6.513a2.476,2.476,0,0,0,4.893,0V25.2H96.011V38.709H73.986a2.467,2.467,0,1,0,0,4.893H98.3a2.512,2.512,0,0,0,2.623-2.446,2.435,2.435,0,0,0-.022-.312Z",
    transform: "translate(-44.33 -12.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    "data-name": "Path 4286",
    d: "M275.538,44.9H250.3a2.46,2.46,0,1,0,0,4.893h25.241a2.7,2.7,0,0,0,2.89-2.446,2.7,2.7,0,0,0-2.89-2.446",
    transform: "translate(-154.427 -28.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287",
    "data-name": "Path 4287",
    d: "M166.194,4.891h.127A2.386,2.386,0,0,0,168.7,2.51V2.382A2.386,2.386,0,0,0,166.321,0h-.127a2.386,2.386,0,0,0-2.382,2.382v.127a2.385,2.385,0,0,0,2.382,2.382",
    transform: "translate(-102.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4288",
    "data-name": "Path 4288",
    d: "M306.45,25.934h.127a2.386,2.386,0,0,0,2.382-2.382v-.127a2.386,2.386,0,0,0-2.382-2.382h-.127a2.386,2.386,0,0,0-2.382,2.382v.126a2.386,2.386,0,0,0,2.382,2.382",
    transform: "translate(-189.666 -13.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4289",
    "data-name": "Path 4289",
    d: "M262.408,25.934h9.734a2.446,2.446,0,1,0,0-4.893h-9.734a2.45,2.45,0,0,0,0,4.893",
    transform: "translate(-162.231 -13.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4290",
    "data-name": "Path 4290",
    d: "M262.592,68.754h-.127a2.386,2.386,0,0,0-2.382,2.382v.127a2.385,2.385,0,0,0,2.382,2.382h.127a2.386,2.386,0,0,0,2.382-2.382v-.127a2.386,2.386,0,0,0-2.382-2.382",
    transform: "translate(-162.23 -42.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    "data-name": "Path 4291",
    d: "M290.665,68.752h-9.733a2.446,2.446,0,1,0,0,4.893h9.733a2.45,2.45,0,0,0,0-4.893",
    transform: "translate(-173.696 -42.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4292",
    "data-name": "Path 4292",
    d: "M204.6,33.013l5.325-10.631a2.232,2.232,0,0,0-1.2-3.065,2.086,2.086,0,0,0-3.107.907l-4.479,8.944-8.15-9.047a2.537,2.537,0,0,0-3.7-.458c-1.12,1.009-1.075,2.351.124,3.682l3.086,3.426a2.539,2.539,0,0,0-.575.983L187.71,40.278a2.247,2.247,0,0,0,1.606,2.9,2.1,2.1,0,0,0,2.961-1.365l3.741-11.13,9.763,10.839a2.537,2.537,0,0,0,3.7.458c1.12-1.009,1.075-2.351-.124-3.682Z",
    transform: "translate(-117.008 -11.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    "data-name": "Path 4293",
    d: "M6.333,42.611a2.283,2.283,0,0,0-2.446,2.137V63.73A2.365,2.365,0,0,0,6.333,66,2.365,2.365,0,0,0,8.78,63.73V44.748a2.283,2.283,0,0,0-2.446-2.137",
    transform: "translate(-2.425 -26.579)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfekHe);
export default __webpack_public_path__ + "static/media/LogoOfek_he.6be1cf0f6d37ad2a2a3287035b9722a2.svg";
export { ForwardRef as ReactComponent };